import { render, staticRenderFns } from "./portal-tech-login.vue?vue&type=template&id=55b37544&scoped=true&"
import script from "./portal-tech-login.vue?vue&type=script&lang=js&"
export * from "./portal-tech-login.vue?vue&type=script&lang=js&"
import style0 from "./portal-tech-login.vue?vue&type=style&index=0&id=55b37544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b37544",
  null
  
)

export default component.exports